// Vendor imports
import '@rails/actiontext'
import 'alpine-turbo-drive-adapter'
import 'cocoon-js-vanilla'
import 'trix'

import { Turbo } from '@hotwired/turbo-rails'
import Alpine from 'alpinejs'
import TomSelect from 'tom-select'

// App components
import BuildSettings from '../build-settings'
import CategorySelector from '../category-selector'
import ContentType from '../content-type'
import Doughnut from '../doughnut'
import EditContent from '../edit-content'
import FinfolioNotes from '../finfolio-notes'
import GenerateField from '../generate-field'
import IdentityTracker from '../identity-tracker'
import Locking from '../locking'
import MultiAttachment from '../multi-attachment'
import MultiSubmission from '../multi-submission'
import NewBusiness from '../new-business'
import Notes from '../notes'
import ResourceItems from '../resource-items'
import SubmissionViewManagement from '../submission-view-management'
import TableNesting from '../table_nesting'
import TimeZoneManager from '../time-zone-manager'
import TooltipManager from '../tooltip-manager'
import util from '../util'
import '../scripts/register-css-variables'

// Stimulus Controllers
import { stimulus } from '../stimulus/application'
import '../stimulus'
import '../turbo'

// Initialize the app
document.addEventListener('DOMContentLoaded', () => {
  window.app = {
    buildSettings: BuildSettings,
    categorySelector: CategorySelector,
    contentType: ContentType,
    doughnut: Doughnut,
    editContent: EditContent,
    finfolioNotes: FinfolioNotes,
    newBusiness: NewBusiness,
    generateField: GenerateField,
    multiAttachment: MultiAttachment,
    multiSubmission: MultiSubmission,
    notes: Notes,
    identityTracker: IdentityTracker,
    locking: new Locking(),
    resourceItems: new ResourceItems(),
    snackBar: stimulus.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller="snack-bar"]')!,
      'snack-bar',
    ),
    submissionViewManagement: new SubmissionViewManagement(),
    tableNesting: TableNesting,
    timeZoneManger: new TimeZoneManager(),
    tomSelect: TomSelect,
    tooltipManager: new TooltipManager(),
    util,
  }

  window.app.locking.init()

  // NOTE: This line is required by the Alpine Turbo Drive Adapter
  // and must be placed before the Alpine.start() call.
  window.Alpine = Alpine

  // Init vendor libraries
  Alpine.start()
  Turbo.session.drive = false
})

document.addEventListener('turbo:load', () => {
  window.app.tooltipManager.init()
  window.app.timeZoneManger.init()
})
